import { userConstants } from "../constants/login.constants";

  function ebinderCustomFileList(state = {}, action) {
     switch (action.type) {
         case userConstants.EBINDERCUSTOMFILELIST_REQUEST:
             return {
                 loading: true
             };
         case userConstants.EBINDERCUSTOMFILELIST_SUCCESS:
             return {
                 items: action.ebinderCustomFileList
             };
         case userConstants.EBINDERCUSTOMFILELIST_FAILURE:
             return {
                 error: action.error
             };
         default:
             return state
     }
 }
 export default ebinderCustomFileList;